// extracted by mini-css-extract-plugin
export var compact = "APoc1";
export var dropContainer = "dGZxs";
export var dropHoverTreatment = "tLIEt";
export var full = "K_Q7X";
export var medium = "SD3tB";
export var tab = "US2jH";
export var tabItemContainer = "VKQ8n";
export var tabListContainer = "OJDtv";
export var tabListRoot = "RDGUB";
export var tabText = "BRlhH";
export var tabTextSelected_Win32Style = "L8o7C";
export var tabTextUnselected = "Jmanx";
export var tabTextUnselectedHover = "Jwc9x";
export var tabTextUnselected_Win32Style = "QPmJo";
export var tabText_Win32Style = "GfKqJ";
export var tab_Win32Style = "JMoq1";